import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kyt-loading-content" }
const _hoisted_2 = {
  key: 0,
  class: "loading-message mt-3 mb-0"
}


import { computed } from 'vue';

const __default__ = {
    name: 'KytChainLoading'
};

interface Props {
    size?: 'sm' | 'md' | 'lg';
    color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
    message?: string;
    overlay?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    size: { default: 'md' },
    color: { default: 'primary' },
    message: {},
    overlay: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const spinnerClass = computed(() => {
    const classes = [`text-${props.color}`];
    
    if (props.size === 'sm') {
        classes.push('spinner-border-sm');
    }
    
    return classes.join(' ');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["kyt-loading-container", { 'overlay': __props.overlay }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["spinner-border", spinnerClass.value]),
        role: "status"
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
      ]))], 2),
      (__props.message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.message), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})